import {
  ADMIN,
  APPROVER,
  APPROVER_JV,
  CAMPAIGN_MANAGER,
  CAMPAIGN_MANAGER_JV,
  CART_QMB_PLANT_APPROVER,
  CREATOR,
  CREATOR_JV,
  QMB_PLANT_APPROVER_JV,
} from '@/helpers/constants';
import visibilityMatrix from '@/helpers/visibilityMatrix';
import { VisibilityMatrixProperties, VisibilityMatrixRole } from '@/types/Matrix';
import useAuth from './useAuth';

const JV_ROLE_EQUIVALENCE: Partial<Record<VisibilityMatrixRole, VisibilityMatrixRole>> = {
  [APPROVER_JV]: APPROVER,
  [CAMPAIGN_MANAGER_JV]: CAMPAIGN_MANAGER,
  [CREATOR_JV]: CREATOR,
  [QMB_PLANT_APPROVER_JV]: CART_QMB_PLANT_APPROVER,
};

const useVisibilityMatrix = () => {
  const authService = useAuth();
  const userRole = authService.getUserRole(true)[0] as VisibilityMatrixRole; // TODO Add type assertion for userRole

  const getFeatureMatrix = (matrixProperties: VisibilityMatrixProperties): VisibilityMatrixRole[] => {
    const { feature, action, workflow, status } = matrixProperties;
    if (!feature || !action) return [];

    const actionDetails = visibilityMatrix[feature][action];

    if (!actionDetails) return [];

    if (workflow && status) {
      return actionDetails?.[workflow]?.[status] ? actionDetails[workflow][status] : [];
    } else if (status) {
      return actionDetails[status] ? actionDetails[status] : [];
    } else {
      return Array.isArray(actionDetails) ? actionDetails : [];
    }
  };

  const canSee = (matrixProperties: VisibilityMatrixProperties) => {
    const authorizedURoles = getFeatureMatrix(matrixProperties);
    const mappedUserRole = JV_ROLE_EQUIVALENCE[userRole] || userRole;

    if (!userRole || authorizedURoles.length === 0) return false;

    return authService.checkRole(ADMIN) || authorizedURoles.includes(userRole) || authorizedURoles.includes(mappedUserRole);
  };

  return {
    canSee,
  };
};

export default useVisibilityMatrix;
